import React from "react";
import apple from "../Db/apple.png";
import google from "../Db/google.png";
import cisco from "../Db/cisco.png";
import microsoft from "../Db/microsoft.png";
import x from "../Db/x.jpg";
import meta from "../Db/meta.jpg";
import myntra from "../Db/myntra.webp";
import nasha from "../Db/nasha.webp";
import shopify from "../Db/shopify.png";
import wordpress from "../Db/wordpress.png";
import wix from "../Db/wix.png";
import paypal from "../Db/paypal.webp";
import alibaba from "../Db/alibaba.png";
import binance from "../Db/binnance.webp";

export default function Marquee() {
  return (
    <div className="flex flex-col w-full justify-center items-center py-6 overflow-hidden">
      <h2 className="text-center text-3xl text-blue-600 font-bold mb-8">
        Orgatro IT Company Trusted by 200+ Global Brands
      </h2>
      <div className="marquee w-full overflow-hidden relative">
        <div className="flex items-center space-x-8 animate-marquee-right">
          {[apple, google, microsoft, cisco, x, meta, myntra, nasha, shopify, wordpress, wix, paypal, alibaba, binance].map((imgSrc, index) => (
            <img
              key={index}
              src={imgSrc}
              alt="Brand logo"
              className="brand-logo w-16 h-16 object-contain remove-bg transition-transform duration-300"
            />
          ))}
        </div>
      </div>
    </div>
  );
}
